<template>
  <div :class="`form-element-viewer ${type}-viewer`">
    <template v-if="value && value.date">
      {{ $d(date) }}
    </template>
    <template v-if="value && value.time">
      {{ value.time }}
    </template>
  </div>
</template>

<script>
export default {
  props: {
    value: { type: [String, Date, Object], default: null },
    type: { type: String, required: true }
  },
  computed: {
    date () {
      return new Date(this.value.date);
    }
  }
};
</script>
